import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '@/hen-ui/utils';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentProps<typeof SwitchPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    data-slot='switch'
    className={cn(
      // Base styles
      'relative inline-flex items-center shrink-0 rounded-full transition-all outline-none peer group/switch',
      // Default neutral
      'bg-neutral-200 h-5 w-8',
      // Checked state
      'data-[state=checked]:bg-primary-700',
      // Focus state
      'focus:ring focus:ring-neutral-100 hover:ring hover:ring-neutral-100',
      // Invalid state
      'aria-[invalid=true]:bg-error-500 aria-[invalid=true]:opacity-30',
      // Checked + Invalid
      'aria-[invalid=true]:data-[state=checked]:bg-error-500 aria-[invalid=true]:data-[state=checked]:opacity-100',
      // Invalid + Focus/Hover
      'aria-[invalid=true]:focus:ring aria-[invalid=true]:focus:ring-error-300 aria-[invalid=true]:hover:ring aria-[invalid=true]:hover:ring-error-300',
      // Disabled state
      'disabled:cursor-not-allowed disabled:opacity-50 disabled:ring-0',
      // Clickable area
      'after:absolute after:-inset-x-3 after:-inset-y-2',
      className,
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb
      data-slot='switch-thumb'
      className='bg-neutral-white rounded-full size-4 group-data-[state=checked]/switch:translate-x-[14px] group-data-[state=unchecked]/switch:translate-x-[2px] pointer-events-none block ring-0 transition-transform'
    />
  </SwitchPrimitive.Root>
));

Switch.displayName = SwitchPrimitive.Root.displayName;

export { Switch };
